import React, { Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { ErrorMessage } from 'formik';
import { injectIntl } from 'react-intl';
import DatePicker from "react-datepicker";
import { TextField } from '../../../shared/TextField';
import { TextAreaField } from "../../../shared/TextAreaField";
import { TrackingForm } from "./TrackingForm";
import { FieldMessages } from "../../../layout/Messages/FieldMessages";
import { NOTIFICATION_CREATE_CAMPAIGN, NOTIFICATION_UPDATE_CAMPAIGN } from "../../../../config/notifications";

function CampaignInfoComponent(props) {
  const { formikProps, initialValues, setInitialValues, campaign } = props;
  const intl = useIntl()
  const isEditMode = campaign && campaign.id;

  const getErrorClass = (formikProps, fieldName) => {
    return formikProps && formikProps.touched && formikProps.touched[fieldName] ? formikProps.errors && formikProps.errors[fieldName] !== undefined ? 'custom-is-invalid' : '' : '';
  }

  return (
    <Fragment>
      <Row className="create-campaign-field-row">
        <Col xs={ 12 } sm={ 12 } className="justify-content-between">
          <label className='form-control-label d-block'>
            <FormattedMessage id="fields.campaignManagement.name"/>
          </label>
          <TextField
            name="campaignManagement.name"
            handleBlur={ formikProps.handleBlur }
            fontAwesome="faBuilding"
            onChange={
              event => {
                formikProps.setFieldValue('name', event.target.value);
              }
            }
            value={ formikProps.values.name }
            errorClass={ getErrorClass(formikProps, 'name') }
          />
          <FieldMessages
            color="danger"
            formikProps={ props.formikProps }
            class="small-field-error"
            showDismiss={ false }
            name="name"
            notificationId={ [NOTIFICATION_UPDATE_CAMPAIGN, NOTIFICATION_CREATE_CAMPAIGN] }
          >
            <ErrorMessage
              name="name"
              component="div"
              data-testid="errors-name"
              className="no-input-margin"
            />
          </FieldMessages>
        </Col>
      </Row>
      <Row className="create-campaign-field-row">
        <Col xs={ 12 } sm={ 12 }>
          <label className='form-control-label d-block'>
            <FormattedMessage id="fields.campaignManagement.notes"/>
          </label>
          <TextAreaField
            name="notes"
            messageId="fields.campaignManagement.notes"
            handleBlur={ formikProps.handleBlur }
            handleChange={
              value => props.formikProps.setFieldValue('notes', value)
            }
            className={ getErrorClass(formikProps, 'notes') }
          />
          <FieldMessages
            color="danger"
            formikProps={ props.formikProps }
            class="small-field-error"
            showDismiss={ false }
            name="notes"
            notificationId={ [NOTIFICATION_UPDATE_CAMPAIGN, NOTIFICATION_CREATE_CAMPAIGN] }
          >
            <ErrorMessage
              name="notes"
              component="div"
              data-testid="errors-notes"
              className="no-input-margin"
            />
          </FieldMessages>
        </Col>
      </Row>
      <Row className="create-campaign-date-row">
        <Col xs={ 12 } sm={ 6 }>
          <label className='form-control-label d-block'>
            <FormattedMessage id="fields.campaignManagement.start_date"/>
          </label>
          <DatePicker
            name="start_date"
            placeholderText={ intl.formatMessage({ id: "fields.campaignManagement.start_date" }) }
            className={ "form-control " + getErrorClass(formikProps, 'start_date') }
            selected={ formikProps.values.start_date ? new Date(formikProps.values.start_date) : Date.now() }
            minDate={ Date.now() }
            showDisabledMonthNavigation
            yearDropdownItemNumber={ 50 }
            scrollableYearDropdown
            showYearDropdown
            dateFormat="dd-MM-yyyy"
            disabled={isEditMode}
            onChange={
              start_date => {
                if (start_date) {
                  formikProps.setFieldValue('start_date', new Date(start_date));

                  if (new Date(formikProps.values.end_date) < new Date(start_date)) {
                    formikProps.setFieldValue('end_date', new Date(start_date));
                  }

                  return;
                }

                formikProps.setFieldValue('start_date', new Date(Date.now()));
              }
            }
            errorClass={ getErrorClass(formikProps, 'start_date') }
          />
          <FieldMessages
            color="danger"
            formikProps={ props.formikProps }
            class="small-field-error"
            showDismiss={ false }
            name="start_date"
            addMargin={ true }
            notificationId={ [NOTIFICATION_UPDATE_CAMPAIGN, NOTIFICATION_CREATE_CAMPAIGN] }
          >
            <ErrorMessage
              name="start_date"
              component="div"
              data-testid="errors-start_date"
            />
          </FieldMessages>
        </Col>
        <Col xs={ 12 } sm={ 6 }>
          <label className='form-control-label d-block'>
            <FormattedMessage id="fields.campaignManagement.end_date"/>
          </label>
          <DatePicker
            name="end_date"
            placeholderText={ intl.formatMessage({ id: "fields.campaignManagement.end_date" }) }
            className={ "form-control " + getErrorClass(formikProps, 'end_date') }
            selected={ formikProps.values.end_date ? new Date(formikProps.values.end_date) : Date.now() }
            minDate={ formikProps.values.start_date ? new Date(formikProps.values.start_date) : Date.now() }
            showDisabledMonthNavigation
            yearDropdownItemNumber={ 50 }
            scrollableYearDropdown
            showYearDropdown
            dateFormat="dd-MM-yyyy"
            disabled={isEditMode}
            onChange={
              end_date => {
                if (end_date) {
                  formikProps.setFieldValue('end_date', new Date(end_date));
                  return;
                }

                if (formikProps.values.start_date) {
                  formikProps.setFieldValue('end_date', formikProps.values.start_date);
                  return;
                }

                formikProps.setFieldValue('end_date', new Date(Date.now()));
              }
            }
            errorClass={ getErrorClass(formikProps, 'end_date') }
          />
          <FieldMessages
            color="danger"
            formikProps={ props.formikProps }
            class="small-field-error"
            showDismiss={ false }
            name="end_date"
            addMargin={ true }
            notificationId={ [NOTIFICATION_UPDATE_CAMPAIGN, NOTIFICATION_CREATE_CAMPAIGN] }
          >
            <ErrorMessage
              name="end_date"
              component="div"
              data-testid="errors-end_date"
            />
          </FieldMessages>
        </Col>
      </Row>
      <hr className="create-campaign-separator pt-1" />
      <TrackingForm
        getErrorClass={ getErrorClass }
        formikProps={ formikProps }
        initialValues={ initialValues }
        setInitialValues={ setInitialValues }
      />
    </Fragment>
  );
}

const CampaignInfo = injectIntl(CampaignInfoComponent)

export { CampaignInfo, CampaignInfoComponent }
